export default "/_next/static/images/0dc87214b4777580011164a334009a19.jpg";